import React from "react";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import { handleLogout } from "../auth/authHelpers";
import InviteNotice from "../organisation/InviteNotice";
import { homePathFor, isWithoutOrganisation, readSession } from "../../utils/organisationApi";

// Shown when login returns no org_id, org_role, or organisation_name.
const NoOrganisationPage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const inviteNotice = location.state?.inviteNotice || "";

  if (!isWithoutOrganisation()) {
    return <Navigate to={homePathFor(readSession())} replace />;
  }

  const dismissNotice = () => {
    navigate(location.pathname, { replace: true, state: {} });
  };

  return (
    <div className="min-h-screen bg-white flex flex-col items-center justify-center px-4 sm:px-6 lg:px-8 py-4 sm:py-6">
      <img src="/sift-hire-logo.png" alt="Logo" className="logo w-48 mb-4 sm:mb-6" />
      <div className="mx-auto w-full max-w-md">
        <div className="bg-white shadow sm:rounded-lg border border-accent-gray-border overflow-hidden">
          <InviteNotice message={inviteNotice} onDismiss={dismissNotice} />
          <div className="px-6 py-10 sm:px-10 text-center">
            <h1 className="text-xl font-semibold">You're not part of any organisation</h1>
            <p className="text-sm text-accent-gray mt-3">
              Ask an Owner or Admin to invite you. You can sign out and use a different account.
            </p>
            <button
              type="button"
              onClick={handleLogout}
              className="mt-6 w-full py-2 px-4 text-xl font-semibold rounded-md text-white bg-accent-blue hover:bg-accent-blue-hover"
            >
              Log out
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NoOrganisationPage;
